import {
  ChargeSupplyTransactions,
  ChargeSupplyTransactionsOrderTypes,
  CsupCsvData,
  SearchChargeSupplyTransactions,
} from "@/models/chargeSupplyTransaction";
import { AxiosResponse } from "axios";
import qs from "qs";
import { httpClient } from "./API";

export const getChargeSupplyTransactionsTotalAPI = async (
  search: SearchChargeSupplyTransactions
) => {
  return httpClient.get(
    "core/internal/calgary/chargerSupplyTransactions/count/",
    {
      params: { ...search },
    }
  );
};

export const getChargeSupplyTransactionsAPI = async (
  nextPage: number,
  pageSize: number,
  search: SearchChargeSupplyTransactions,
  sort?: ChargeSupplyTransactionsOrderTypes
): Promise<AxiosResponse<ChargeSupplyTransactions[]>> => {
  const sortParams: string[] = [];
  if (sort) {
    Object.keys(sort).forEach((it) => {
      const key = it as keyof ChargeSupplyTransactionsOrderTypes;
      if (sort[key]) {
        sortParams.push([key, sort[key]].join(","));
      }
    });
  }

  return httpClient.get("core/internal/calgary/chargerSupplyTransactions/", {
    params: { ...search, sort: sortParams, page: nextPage, size: pageSize },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

export const getChargeSupplyTransactionsCsvAPI = async (
  search: SearchChargeSupplyTransactions,
  sort?: ChargeSupplyTransactionsOrderTypes
): Promise<AxiosResponse<CsupCsvData[]>> => {
  const sortParams: string[] = [];
  if (sort) {
    Object.keys(sort).forEach((it) => {
      const key = it as keyof ChargeSupplyTransactionsOrderTypes;
      if (sort[key]) {
        sortParams.push([key, sort[key]].join(","));
      }
    });
  }

  return httpClient.get("core/internal/calgary/chargerSupplyTransactions/csv/", {
    params: { ...search, sort: sortParams },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};
